<template>
  <div>
    <div
      v-show="paymentdetails"
      class="paymentdetails"
    >
      <payment-details
        @togglePaymentBtn="toggle"
        @getCardFields="submitForm"
      />
    </div>
    <div
      v-show="!paymentdetails"
      class="review"
    >
      <review-purchase @submitPayment="handleSubmit" />
    </div>

    <div
      v-if="loader"
      class="loading_log"
    >
      <spin-loading
        loadingstatus=""
        loadingmessage=""
      />
    </div>
  </div>
</template>

<script>
import SpinLoading from '../SpinLoading'
import PaymentDetails from './PaymentDetails.vue';
import ReviewPurchase from './ReviewPurchase.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: { ReviewPurchase, PaymentDetails,SpinLoading },
  data() {
    return {
      paymentdetails: true,
      cardholder_name: null,
      residentialAddress: null,
      selectedcountry: null,
      postal_code: null,
      state: null,
      city: null,
      loader:false
    };
  },
  computed: {
    ...mapGetters({
      userBasedPlanInfo: 'subscription/userBasedPlanInfo',
      subscriptionSuccessData: 'subscription/subscriptionSuccessData',
      subscriptionErrorMessage:'subscription/subscriptionErrorMessage'
    }),
  },
  mounted() {
    this.createStripe();
  },
  methods: {
    ...mapActions({
      createSubscription: 'subscription/createSubscription'
    }),
    toggle() {
      this.paymentdetails = false;
    },
    submitForm(val) {
      this.cardholder_name = val.cardholder_name;
      this.residentialAddress = val.residentialAddress;
      this.selectedcountry = val.selectedcountry;
      this.city = val.city;
      this.state = val.state;
      this.postal_code = val.postal_code;
    },

    createStripe() {
      this.stripe = window.Stripe('pk_live_S8usTeaeoMebdqM2VWSJ2TJo');
      this.elements = this.stripe.elements();
      const cardElement = this.elements.create('card', {
        hidePostalCode: true,
      });
      cardElement.mount('#card-element');
    },

    async handleSubmit() {
      try{
        this.loader = true
        await this.$nextTick()
        await this.$nextTick()
        let cardElement = this.elements.getElement('card');
        const { paymentMethod, error } = await this.stripe.createPaymentMethod({
          type: 'card',
          card: cardElement,
          billing_details: {
            address: {
              line1: this.residentialAddress,
              line2: this.residentialAddress,
              country: this.selectedcountry,
              postal_code: this.postal_code,
              state: this.state,
              city: this.city,
            },
             name:this.cardholder_name
          },
         
        });

        if (error) {
           this.paymentdetails = true;
          this.$alert(
          error.message,
          'Error',
          'error',
        )

          return;
        }
        const subscription = await this.createSubscription({
          plan: this.userBasedPlanInfo.id,
          payment_method: paymentMethod.id,
        });

        if (!subscription) {
           this.paymentdetails = true;
          throw this.subscriptionErrorMessage
        } else {
          let subscriptionstatus = this.subscriptionSuccessData.subscription;

          if (subscriptionstatus.latest_invoice.payment_intent) {
            const { client_secret, status } =
              subscriptionstatus.latest_invoice.payment_intent;
            if (status === 'requires_action') {
              const { error: confirmationError } =
                await this.stripe.confirmCardPayment(client_secret);
              if (confirmationError) {
                return;
              }
            }

            this.$router.push('/accountsummary');
          }
        }
      }catch(error){
        this.$alert(
          error,
          'Error',
          'error',
        )
      }finally{
        this.loader = false
      }
    },
  },
};
</script>

<style>
</style>